// extracted by mini-css-extract-plugin
export default {"container":"Header_container__TsUVY","text":"Header_text__Ib48F","tiles":"Header_tiles__2f5iT"};